// @ts-nocheck
import toolkitConstants from "@toolkit/constants";
import overrideProps from "@toolkit/Framework/Common/Utilities/overrideProps";

/* Store Custom Code - Start */
import { Dictionary } from "@insite/client-framework/Common/Types";
import { VariantView } from "@store/Framework/Store/Store/Pages/ProductDetails/ProductDetailsState";
/* Store Custom Code - End */

export default overrideProps(toolkitConstants, {
    formField: {
        borderWidth: 1, // Store Custom Code
    },
    /* Store Custom Code - Start */
    showSingleUOM: false,
    sampleUOM: "SAMPLE",
    customerType: {
        b2b: "B2B",
        b2c: "B2C",
    },
    pageType: {
        createB2BAccount: "CreateB2BAccountPage",
        myDocuments: "MyDocumentsPage",
    },
    variantView: {
        tile: "tile",
        trim: "trim",
    } as Dictionary<VariantView>,
    /* Store Custom Code - End */
});

export const excludedRoles = ["SnapPay_User", "CSR"];

export const userRoles = {
    snapPay: "SnapPay_User",
};
